import { executeWorkloadsDataFlow } from '../operations/executeWorkloadsDataFlow';
export var workloadsConfigOptions = {
    key: 'Workloads',
    getServerGeneratedConfig: function (context) {
        return executeWorkloadsDataFlow(context);
    },
};
//# sourceMappingURL=workloadsConfigOptions.js.map